// Design System - Layout Components
// Inspired by React Native HStack/VStack approach

import styled from 'styled-components';
import { spacing } from './spacing';
import { breakpoints } from '../constants';

export const VStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${(props) => spacing[props.gap] || spacing.medium};
    align-items: ${(props) => props.alignItems || 'stretch'};
    justify-content: ${(props) => props.justifyContent || 'flex-start'};
`;

export const HStack = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${(props) => spacing[props.gap] || spacing.medium};
    align-items: ${(props) => props.alignItems || 'center'};
    justify-content: ${(props) => props.justifyContent || 'flex-start'};
`;

export const Container = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 ${spacing.medium};

    @media (max-width: ${breakpoints.mobileTablet}px) {
        padding: 0 ${spacing.small};
    }
`;
